const { createApp } = Vue

createApp({
	data() {
		return {
			loading: false,
			success: null,
      products: [],
			error: null,
			form: {
				firstName: "",
				lastName: "",
				email: "",
				contact: "",
				productName: "",
				productCategory: "",
				source: "",
			},
			errors: {
				firstName: "",
				lastName: "",
				email: "",
				contact: "",
				productName: "",
				productCategory: "",
				source: "",
				invoice: "",
				invoiceNumber: "",
			},
		}
	},
	computed: {
		hasErrors() {
			return Object.values(this.errors).some((error) => error !== "")
		},
	},
	methods: {
		validateField(field) {
			this.errors[field] = ""

			if (field === "firstName" && !this.form.firstName.trim()) {
				this.errors.firstName = "First Name is required"
			}
			if (field === "lastName" && !this.form.lastName.trim()) {
				this.errors.lastName = "Last Name is required"
			}
			if (field === "email") {
				if (!this.form.email.trim()) {
					this.errors.email = "Email is required"
				} else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email)) {
					this.errors.email = "Please enter a valid email address"
				}
			}
			if (field === "contact" && this.form.contact) {
				if (!/^\d{10}$/.test(this.form.contact)) {
					this.errors.contact = "Contact Number must be a 10-digit number"
				}
			}
			if (field === "productName" && !this.form.productName.trim()) {
				this.errors.productName = "Product Name is required"
			}
			if (field === "productCategory" && this.form.productCategory && this.form.productCategory.length < 3) {
				this.errors.productCategory = "Product Category must be at least 3 characters"
			}
			if (field === "source" && !this.form.source) {
				this.errors.source = "Please select a source"
			}
			if (field === "invoice") {
				const fileInput = document.getElementById("inputInvoice")
				if (fileInput.files.length > 0) {
					const file = fileInput.files[0]
					const allowedTypes = ["image/jpeg", "image/png", "application/pdf"]
					const maxSize = 1 * 1024 * 1024
					if (!allowedTypes.includes(file.type)) {
						this.errors.invoice = "File must be a JPEG, PNG, or PDF"
					} else if (file.size > maxSize) {
						this.errors.invoice = "File size must not exceed 1MB"
					}
				}
			}
			if (field === "invoiceNumber" && !this.form.invoiceNumber.trim()) {
				this.errors.invoiceNumber = "Invoice Number is required"
			}
		},
		validateForm() {
			// Validate all fields before submission
			this.validateField("firstName")
			this.validateField("lastName")
			this.validateField("email")
			this.validateField("contact")
			this.validateField("productName")
			this.validateField("productCategory")
			this.validateField("source")
			this.validateField("invoice")
			this.validateField("invoiceNumber")
			return !this.hasErrors
		},


    async categoryChange(e){
      console.log(e.target.value);
      if(e.target.value){
        this.validateField("productCategory")
        const products = await this.fetchCollectionProducts(e.target.value);
        this.products = products;
        this.form.productName = '';
      }
    },

    productChange(e){
      this.form.productName = e.target.value;
      this.validateField("productName")
    },

    async fetchCollectionProducts(handle) {
			try {
				const response = await fetch(`/collections/${handle}/products.json`)
				const data = await response.json()
				return data.products
			} catch (error) {
				console.error("Error fetching product:", error)
			}
		},

		async submitForm(e) {
			e.preventDefault()

			// Validate all fields
			if (!this.validateForm()) {
				this.error = "Please fix the errors in the form"
				return
			}

			this.loading = true
			this.success = null
			this.error = null

			const fileInput = document.getElementById("inputInvoice")
			let uploadedFileName = null

			// Handle file upload
			if (fileInput.files.length > 0) {
				const formdata = new FormData()
				formdata.append("file", fileInput.files[0])

				try {
					const uploadRes = await fetch("https://api.baserow.io/api/user-files/upload-file/", {
						method: "POST",
						headers: { Authorization: "Token VONIfz5XZCbJbzC2cZdxTrzihDcjoREJ" },
						body: formdata,
					})
					const uploadData = await uploadRes.json()
					if (uploadRes.ok) {
						uploadedFileName = uploadData.name
					} else {
						throw new Error(uploadData.error || "File upload failed")
					}
				} catch (err) {
					this.error = err.message
					this.loading = false
					return
				}
			}

			// Prepare row data
			const rowData = {
				"First Name": this.form.firstName,
				"Last Name": this.form.lastName,
				Email: this.form.email,
				Contact: this.form.contact,
				"Product Name": this.form.productName,
				"Product Category": this.form.productCategory,
				"Invoice Number": this.form.invoiceNumber,
				Source: this.form.source,
			}

			if (uploadedFileName) {
				rowData["Invoice"] = [{ name: uploadedFileName }]
			}

			try {
				const res = await fetch("https://api.baserow.io/api/database/rows/table/686989/?user_field_names=true", {
					method: "POST",
					headers: {
						Authorization: "Token VONIfz5XZCbJbzC2cZdxTrzihDcjoREJ",
						"Content-Type": "application/json",
					},
					body: JSON.stringify(rowData),
				})
				const data = await res.json()
				if (res.ok) {
					this.success = "Form submitted successfully!"
					e.target.reset()
					this.form = {
						firstName: "",
						lastName: "",
						email: "",
						contact: "",
						productName: "",
						productCategory: "",
						invoiceNumber: "",
						source: "",
					}
					this.errors = {
						firstName: "",
						lastName: "",
						email: "",
						contact: "",
						productName: "",
						productCategory: "",
						source: "",
						invoice: "",
						invoiceNumber: "",
					}
				} else {
					this.error = data.detail || "Failed to submit form"
				}
			} catch (err) {
				this.error = err.message
			}

			this.loading = false
		},
	},
}).mount("#warrantyApp")
